import { getCurrentInstance } from 'vue'

export function useKeyTranslation() {
  const instance = getCurrentInstance()

  if (!instance?.proxy) {
    throw new Error('useKeyTranslation must be used inside setup()')
  }

  const proxy = instance.proxy

  function translateKey(rawValue: string, namespace: string): string {
    if (!rawValue || !namespace) return rawValue

    const parts = rawValue.split(':').map(part => {
      const key = part.trim().split('.').pop()
      return key ?? part.trim()
    })

    const translatedParts = parts.map(part => proxy.$t(`${namespace}.${part}`, { default: part }))

    return translatedParts.join(': ')
  }

  return {
    translateKey,
  }
}
